export default __webpack_public_path__ + "static/media/taxes-2.52d84ff4.png";